import { render, staticRenderFns } from "./CompetitionRegistration_phone.vue?vue&type=template&id=272a0958&scoped=true"
import script from "./CompetitionRegistration_phone.vue?vue&type=script&lang=js"
export * from "./CompetitionRegistration_phone.vue?vue&type=script&lang=js"
import style1 from "./CompetitionRegistration_phone.vue?vue&type=style&index=1&id=272a0958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272a0958",
  null
  
)

export default component.exports